import styled, { keyframes } from "styled-components";

export const VinylSkeleton = () => (
  <SkeletonCardContainer>
    <SkeletonContent>
      <SkeletonImage />
      <SkeletonTitle />
      <SkeletonDescription />
      <SkeletonButton />
    </SkeletonContent>
  </SkeletonCardContainer>
);

const shimmer = keyframes`
    0% { background-position: -400px 0; }
    100% { background-position: 400px 0; }
`;

const SkeletonCardContainer = styled.div`
  max-width: 213px;
  width: 213px;
  max-height: 344px;
  height: 344px;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  display: flex;
  flex-direction: column;
`;

const SkeletonContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  margin-left: 30px;
  margin-right: 30px;
  margin-top: 20px;
  min-height: 312px;
`;

const SkeletonBase = styled.div`
  background: ${(props) => props.theme.colors.gray400};
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      transparent,
      ${(props) => props.theme.colors.gray300},
      transparent
    );
    animation: ${shimmer} 1.2s infinite;
  }
`;

const SkeletonImage = styled(SkeletonBase)`
  width: 152px;
  height: 149px;
  margin-bottom: 10px;
`;

const SkeletonTitle = styled(SkeletonBase)`
  width: 100%;
  height: 20px;
  margin-bottom: 8px;
`;

const SkeletonDescription = styled(SkeletonBase)`
  width: 100%;
  height: 57px;
  margin-bottom: 12px;
`;

const SkeletonButton = styled(SkeletonBase)`
  width: 54px;
  height: 22px;
  border-radius: 30px;
`;

export default VinylSkeleton;
